export const FEET_VALUE: number = 3.280839895; // mètres
export const MILE_VALUE: number = 1609.344; //  mètres
export const MILES_PER_HOUR_VALUE: number = 0.6213711922; // KMH
